/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./partyInfo.vue?vue&type=template&id=ec8c3dfa&scoped=true&"
import script from "./partyInfo.vue?vue&type=script&lang=js&"
export * from "./partyInfo.vue?vue&type=script&lang=js&"
import style0 from "./partyInfo.vue?vue&type=style&index=0&id=ec8c3dfa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8c3dfa",
  null
  
)

export default component.exports